import type { Product } from "@stockline/shared/types/inventory/product"
import type { OfflineResourceConfig } from "../../../types"
import { PRODUCT_TABLE } from "./db"

export const productConfig: OfflineResourceConfig<Product> = {
  name: "products",
  syncDisabled: false,
  // Catalogue-bound tenants (e.g. Delanchy, ~39k products) pull the whole
  // catalogue as `reference` on cold start — products is the critical path
  // (~0.85s/page @1000). 3000/page cuts the request count ~3x (~745KB→~2.2MB
  // decoded per page, well under the `pre_orders @250 = 3.4MB` ceiling the API
  // already serves). Small catalogues stay 1 page. STK-1960.
  pageSize: 3000,
  endpoints: {
    full: "/api/v2/products",
    delta: "/api/v2/products/changes",
    push: "/api/v2/products/changes",
  },
  tableName: PRODUCT_TABLE,
  primaryKey: "id",
  indexes: {
    companyId: "companyId",
    sku: "sku",
    code: "code",
    isSleeping: "isSleeping",
  },
  applyChange: (local, patch) => ({ ...local, ...patch }),
}
